// extracted by mini-css-extract-plugin
module.exports = {"tableBody":"savingPlans_tableBody__1BkPf","display":"savingPlans_display__1teqD","balanceDisplay":"savingPlans_balanceDisplay__2g7d6"};